import { JobLiquidity } from "@/types";

const labels: Record<JobLiquidity, string> = {
  [JobLiquidity.UNKNOWN]: "Unknown",
  [JobLiquidity.THIN]: "Low",
  [JobLiquidity.MODERATE]: "Moderate",
  [JobLiquidity.LIQUID]: "High",
  [JobLiquidity.VERY_LIQUID]: "Very High",
};

export const liquidity = {
  label: (level: JobLiquidity): string => labels[level],
};
